/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1PersonMutationRequest,
  PostApiV1PersonMutationResponse,
  PostApiV1Person400,
  PostApiV1Person401,
  PostApiV1Person409,
  PostApiV1Person500,
} from "../../types/personRegisterController/PostApiV1Person.ts";

function getPostApiV1PersonUrl() {
  const res = { method: "POST", url: `/api/v1/person` as const };
  return res;
}

/**
 * @description Cria uma nova pessoa com os dados informados. **(Requer Authorization para autenticação)**
 * @summary Criar pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person}
 */
export async function postApiV1Person(
  data?: PostApiV1PersonMutationRequest,
  config: Partial<RequestConfig<PostApiV1PersonMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1PersonMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Person400
      | PostApiV1Person401
      | PostApiV1Person409
      | PostApiV1Person500
    >,
    PostApiV1PersonMutationRequest
  >({
    method: "POST",
    url: getPostApiV1PersonUrl().url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
